'use client';

import React, { Suspense } from 'react';
import { SimpleGrid, Text } from '@chakra-ui/react';
import { IFavourites } from '@/_types';
import ProductCard from '@/_components/Card';
import { useTranslations } from 'next-intl';
import useProductDiscount from '@/_hooks/useProductDiscount';

const Favourites = ({
  data,
}: {
  data: IFavourites | undefined;
}) => {
  const t = useTranslations();
  const { discounts } = useProductDiscount();

  if (!data || data?.favourites?.length === 0) {
    return null;
  }

  return (
    <Suspense fallback={<p>{t('loading')}</p>}>
      <Text fontSize={{ base: 20, lg: 24 }} fontWeight={700}>
        {t('recommend')}
      </Text>
      <SimpleGrid as='section' mt={4} columns={{ base: 2, md: 3, lg: 4 }} gap={4}>
        {data?.favourites?.map((product) => (
          <ProductCard
            key={product?.id}
            category={null}
            discounts={discounts}
            product={product}
          />
        ))}
      </SimpleGrid>
    </Suspense>
  );
};

export default Favourites;
